const CLOCK_COLOUR_PATH =
  "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/";

export class BugStat {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "BugStat";
    this.scene = "BugStat";
    this.data = [];
    this.page = 10004;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });

    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "200"; // Number
      }).value =
        CLOCK_COLOUR_PATH +
          options.team?.variables?.[options.kit + "_clock_bg"] || "";
      xml.payload.field.find((item) => {
        return item.attr.name === "201"; // Number
      }).value =
        CLOCK_COLOUR_PATH +
          options.team?.variables?.[options.kit + "_clock_text"] || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "101"; // Number
      }).value = options.player.last_name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "107"; // Number
      }).value = options.stats?.[0]?.category || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "108"; // Number
      }).value = options.stats?.[0]?.value || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "109"; // Number
      }).value = options.stats?.[1]?.category || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "110"; // Number
      }).value = options.stats?.[1]?.value || "";

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
